import React, { useEffect, useState } from "react";
import AppRouter from "./router/AppRouter";
import AuthModal from "./components/auth/AuthModal";

function App() {
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const savedAuth = localStorage.getItem("auth");
    if (savedAuth === "true") {
      setIsAuth(true);
    }
  }, []);

  const handleLoginSuccess = () => {
    localStorage.setItem("auth", "true");
    setIsAuth(true);
  };

  return (
    <div>
      {!isAuth ? (
        <AuthModal setAuthModalIsOpen={handleLoginSuccess} />
      ) : (
        <AppRouter />
      )}
    </div>
  );
}

export default App;